import React, { useRef, useState, useEffect } from 'react';
import { Loader } from 'htlib-copy';
import { string, arrayOf, number, func, bool } from 'prop-types';

import './Localization.scss';

export default function Localization({ src, coords, onLoad, canLoad }) {
  const container = useRef(null);
  const canTriggerOnLoad = useRef(true);
  const boxPosition = useRef({});
  const imgOrientation = useRef('');

  const [img, setImg] = useState(null);

  const top = { top: '0', height: boxPosition.current.top, width: '100%' };
  const bottom = { bottom: '0', height: boxPosition.current.bottom, width: '100%' };
  const left = {
    top: top.height,
    bottom: bottom.height,
    left: '0',
    width: boxPosition.current.left,
  };

  const right = {
    top: top.height,
    bottom: bottom.height,
    right: '0',
    width: boxPosition.current.right,
  };

  function onImageLoad(initialWidth, initialHeight) {
    const [x1, y1, x2, y2] = coords || [0, 0, 0, 0];

    return function load() {
      boxPosition.current = {
        top: `${(y1 / initialHeight) * 100}%`,
        bottom: `${(1 - y2 / initialHeight) * 100}%`,
        right: `${(1 - x2 / initialWidth) * 100}%`,
        left: `${(x1 / initialWidth) * 100}%`,
      };
    };
  }

  useEffect(() => {
    return function cleanup() {
      canTriggerOnLoad.current = false;
    };
  }, []);

  useEffect(() => {
    if (canLoad) {
      const newImg = new Image();
      newImg.onload = () => {
        if (canTriggerOnLoad.current) setImg(newImg);
        onImageLoad(newImg.width, newImg.height)();
      };
      newImg.onerror = onLoad;
      newImg.src = src;
      newImg.className = 'Localization__image';
      imgOrientation.current = newImg.width / newImg.height >= 1 ? 'horizontal' : 'vertical';
    }
    // eslint-disable-next-line
  }, [canLoad]);

  useEffect(() => {
    if (img && container.current) {
      container.current.appendChild(img);
      onLoad();
    }
    // eslint-disable-next-line
  }, [img, container]);

  if (!img || !canLoad) return <Loader height="35px" />;

  return (
    <div className={`Localization Localization--${imgOrientation.current}`} ref={container}>
      {coords && (
        <div className="ImageWithLoc__Overlay">
          <div className="Overlay__top" style={top} />
          <div className="Overlay__bottom" style={bottom} />
          <div className="Overlay__left" style={left} />
          <div className="Overlay__right" style={right} />
          <div className="Overlay__box" style={boxPosition.current} />
        </div>
      )}
    </div>
  );
}

Localization.propTypes = {
  src: string.isRequired,
  coords: arrayOf(number),
  onLoad: func.isRequired,
  canLoad: bool.isRequired,
};

Localization.defaultProps = {
  coords: null,
};
